import React from 'react';
import RollRow from './RollRow';
import { API_BASE } from "../apiBase";

function RollTable({ tail = "", onEdit, canEdit=false }) {
  const [rolls, setRolls] = React.useState([]);
  const [msg, setMsg] = React.useState("");

  const load = React.useCallback(async () => {
    if (!tail) {
      setMsg("No aircraft selected");
      setRolls([]);
      return;
    }
    try {
      setMsg("");

      /**
     * Ids must be URL-encoded because they may contain special characters
     * such as spaces or slashes.
     */
      const res = await fetch(`${API_BASE}/api/rollouts?tail=${encodeURIComponent(tail)}`);
      if (!res.ok) {
        setMsg(`Error ${res.status}: ${await res.text()}`);
        setRolls([]);
        return;
      }

      const json = await res.json();
       const rows = Array.isArray(json?.rollouts) ? json.rollouts : [];

      // force stable order: Takeoff then Landing
      const takeoff = rows.find((r) =>
        String(r?.id ?? "").toLowerCase().includes("takeoff")
      );
      const landing = rows.find((r) =>
        String(r?.id ?? "").toLowerCase().includes("landing")
      );
      
      setRolls([takeoff, landing].filter(Boolean));

    } catch (e) {
      setMsg("Server not reachable");
      setRolls([]);
    }
  }, [tail]);

  React.useEffect(() => {
    load();
  }, [load]);


    return (
      <div>
        <table id="rollouts">
            <caption className='caption_text'>
                Takeoff and Landing distances required to clear 50ft. obstacle
                {msg ? ` — ${msg}` : ""}
            </caption>   
            <thead>
                <tr>
                    <th className='item_box'>item</th>
                    <th className='sea_box'>Sea_Level</th>
                    <th className='msl_box'>Field Elevation</th>
                    <th className='unit_box'>Units</th>
                    {canEdit && <th className='edit_box'>Edit</th>}
                </tr>
            </thead>
            <tbody>

                {/* RollTable receives an argument named 'rollout' which is the array of JSON Objects from the data file */}
                {/* The contents of the tbody element are created by calling the 'map' method on the array 'rollout' */}
                {/* The map method is supplied the following anonymous function*/}
                {/* map calls the anonymous function on each object array of rollout to create one roll
                component for each roll in the array */}
                {/*need colspan of 5 to match number of columns in table*/}
                {rolls.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ padding: 12 }}>
                    (No rollout rows returned)
                  </td>
                </tr>
              ) : (
                       rolls.map((r, i) => (
                       <RollRow 
                       key={r?.id ?? i} 
                       roll={r} 
                       onEdit={onEdit}
                       canEdit={canEdit}
                       />
                       ))
              )}
            </tbody>
        </table>
        
        {/* notes section */}
        <div style={{marginTop: "8px"}} className="rollout-notes">
            <table className="rollout-notes-table">
            <tbody>
              <tr>
                <td>
                  Fixed Pitch Prop: add 15% to distance for each 1000 ft. increase in Density Altitude up to 8000 ft.
                </td>
              </tr>

           <tr>
        <td>
          Constant Speed Prop: add 12% to distance for each 1000 ft. increase in Density Altitude up to 6000 ft.
        </td>
      </tr>

      <tr>
        <td>
          Reach 70% of rotation speed before 30% to 50% of available takeoff distance. If not then abort takeoff.
        </td>
      </tr>

      </tbody>
     </table>
    </div>   

    </div> 
    );
}
export default RollTable;
